/** Application constants. */

// Auto-detect API base URL based on current hostname
// This allows the app to work when accessed from other PCs on the network
// or when frontend is hosted separately from backend
function getApiBaseUrl(): string {
  // Use environment variable if set (highest priority)
  // Check for both undefined and empty string
  const envApiUrl = import.meta.env.VITE_API_BASE_URL;
  if (envApiUrl && envApiUrl.trim() !== '') {
    return envApiUrl;
  }
  
  // If accessing from localhost, use localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  
  // Production: If frontend is on HTTPS, assume API is on same domain with /api
  // This works when frontend and backend are on same domain
  if (window.location.protocol === 'https:') {
    // Try same domain first (if backend is proxied)
    const fallbackUrl = `${window.location.protocol}//${window.location.host}`;
    return fallbackUrl;
  }
  
  // Development/Network: Use the current hostname
  // This will use the server's IP when accessed from another PC
  return `http://${window.location.hostname}:5000`;
}

function getWsBaseUrl(): string {
  // Use environment variable if set (highest priority)
  // Check for both undefined and empty string
  const envWsUrl = import.meta.env.VITE_WS_BASE_URL;
  if (envWsUrl && envWsUrl.trim() !== '') {
    return envWsUrl;
  }
  
  // If accessing from localhost, use localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  
  // Production: If frontend is on HTTPS, use same domain
  // This works when frontend and backend are on same domain
  if (window.location.protocol === 'https:') {
    // Try same domain first (if backend is proxied)
    const fallbackUrl = `${window.location.protocol}//${window.location.host}`;
    return fallbackUrl;
  }
  
  // Development/Network: Use the current hostname
  return `http://${window.location.hostname}:5000`;
}

export const API_BASE_URL = getApiBaseUrl();
export const WS_BASE_URL = getWsBaseUrl();

export const CHART_COLORS = {
  text: '#a0aec0',
  border: '#4a5568',
  background: '#1a202c',
};

export const RETRY_CONFIG = {
  maxRetries: 2,
  baseDelay: 500,
};

// API Key for authentication (from environment variable)
export const API_KEY = import.meta.env.VITE_API_KEY || '';

